import React from "react";
import MUIChip from "@mui/material/Chip";

export default class Chip extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    /**
     * Returns the sx styles for the chip, including highlight styles if
     * selectable.
     */
    getSx() {
        let sx = {};

        if (this.props.isTransparent) {
            sx.backgroundColor = "transparent";
        }
        if (this.props.selectable) {
            sx.borderRadius = "4px";
            // Use MUI standardized elevation shadow
            sx.boxShadow = (theme) => theme.shadows[1];

            if (this.props.selected) {
                sx.backgroundColor = (theme) => theme.palette.primary.main;
                sx.color = (theme) => theme.palette.primary.contrastText;
                sx['&:hover'] = { backgroundColor: (theme) => theme.palette.primary.main }
            }
        }

        if (this.props.fullWidth) {
            sx.width = "100%";
            // Force chip label/content to left align
            sx['.MuiChip-label'] = {
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-start'
            };
        }

        return sx;
    }

    /**
     * Renders a MUI Avatar with an avatar and text.
     */
    render() {
        const label = this.getLabel();

        return (
            <MUIChip
                title={this.props.tooltip ? this.props.tooltip : label}
                avatar={this.renderAvatar()}
                label={label}
                onClick={this.props.onClick}
                onDelete={this.props.onDelete}
                clickable={this.props.clickable}
                deleteIcon={this.props.deleteIcon}
                sx={this.getSx()}
            />
        );
    }

    /**
     * Renders a MUI Avatar. Defaults to null; subclasses should override.
     */
    renderAvatar() {
        return this.props.avatar;
    }

    /**
     * @returns {string} The label of the chip. Defaults to null; subclasses
     * should override.
     */
    getLabel() {
        return this.props.label;
    }
}